<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/16LOZ8/images/cover.jpeg?1730053895060" alt="This image is the cover for the book The Feeding #1, The Feeding"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">The Feeding #1, The Feeding
      </h1>
      <p class="bookDescription body article font2">
        <p>In this extra-length horror one-shot, Nolan Ward has done everything to forget his disturbing past. Drinking. Drugs. Day-trading. Sex. And still, that past has caught up with him in the form of a twisted painting called"The Feeding…which eats people. And it's hungry. Can Nolan stop this demon, or will he be devoured like so many others before him? From the team behind the hit series"Canto, Eisner and GLAAD Award-nominated writer"DAVID M. BOOHER"(Canto, Ghostbusters, RAIN) and fan-favorite artist"DREW ZUCKER"(Canto,"The House) take you on a surreal journey into one man's bloody psyche. A throwback to the vibes of"Tales from the Crypt"and"Creepshow;when art is dangerous, no one is safe. Chilling, nightmarish, and beautifully presented,"THE FEEDING"is exactly what you want from a horror one-shot. In keeping with the title, I devoured it. --Rio Youers"(Sleeping Beauties,"No Second Chances)</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        David M. Booher, Drew Zucker
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Image Comics
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?9a542d0c